import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function TopicsGuidesSection() {
  const { t } = useTranslation();

  const topics = [
    {
      icon: 'ri-grid-line',
      title: t('home.topics.topic1Title'),
      desc: t('home.topics.topic1Desc'),
      image:
        'https://readdy.ai/api/search-image?query=A%20modern%20laptop%20screen%20displaying%20a%20neatly%20organized%20product%20spreadsheet%20with%20colorful%20thumbnail%20images%20and%20category%20columns%2C%20placed%20on%20a%20clean%20bright%20desk%20with%20soft%20natural%20light%2C%20minimal%20tech%20workspace%20photography%2C%20fresh%20modern%20aesthetic%2C%20high%20detail&width=800&height=600&seq=topic-spreadsheet&orientation=landscape',
    },
    {
      icon: 'ri-star-line',
      title: t('home.topics.topic2Title'),
      desc: t('home.topics.topic2Desc'),
      image:
        'https://readdy.ai/api/search-image?query=A%20product%20review%20concept%20with%20five%20gold%20stars%20and%20a%20rating%20card%20on%20a%20clean%20light%20desk%2C%20soft%20natural%20lighting%2C%20minimal%20photography%2C%20warm%20modern%20aesthetic%2C%20high%20detail%2C%20editorial%20composition&width=800&height=600&seq=topic-review&orientation=landscape',
    },
    {
      icon: 'ri-truck-line',
      title: t('home.topics.topic3Title'),
      desc: t('home.topics.topic3Desc'),
      image:
        'https://readdy.ai/api/search-image?query=A%20kraft%20cardboard%20delivery%20box%20sealed%20with%20tape%20and%20a%20shipping%20label%20on%20a%20light%20studio%20background%2C%20soft%20even%20lighting%2C%20minimal%20product%20photography%2C%20clean%20modern%20aesthetic%2C%20high%20detail%20cardboard%20texture&width=800&height=600&seq=topic-shipping&orientation=landscape',
    },
    {
      icon: 'ri-coupon-3-line',
      title: t('home.topics.topic4Title'),
      desc: t('home.topics.topic4Desc'),
      image:
        'https://readdy.ai/api/search-image?query=A%20paper%20discount%20coupon%20with%20a%20dashed%20cut%20line%20and%20a%20pair%20of%20scissors%20on%20a%20light%20studio%20background%2C%20soft%20natural%20lighting%2C%20minimal%20photography%2C%20clean%20modern%20aesthetic%2C%20high%20detail%20paper%20texture&width=800&height=600&seq=topic-coupon&orientation=landscape',
    },
    {
      icon: 'ri-price-tag-3-line',
      title: t('home.topics.topic5Title'),
      desc: t('home.topics.topic5Desc'),
      image:
        'https://readdy.ai/api/search-image?query=A%20red%20price%20tag%20with%20a%20percent%20off%20discount%20symbol%20hanging%20on%20a%20string%20against%20a%20light%20studio%20background%2C%20soft%20even%20lighting%2C%20minimal%20product%20photography%2C%20clean%20modern%20aesthetic%2C%20high%20detail&width=800&height=600&seq=topic-discount&orientation=landscape',
    },
    {
      icon: 'ri-archive-line',
      title: t('home.topics.topic6Title'),
      desc: t('home.topics.topic6Desc'),
      image:
        'https://readdy.ai/api/search-image?query=A%20bright%20modern%20warehouse%20interior%20with%20organized%20shelves%20of%20cardboard%20boxes%20and%20a%20clean%20floor%2C%20soft%20even%20lighting%2C%20minimal%20photography%2C%20fresh%20modern%20aesthetic%2C%20high%20detail%2C%20editorial%20composition&width=800&height=600&seq=topic-warehouse&orientation=landscape',
    },
    {
      icon: 'ri-shield-check-line',
      title: t('home.topics.topic7Title'),
      desc: t('home.topics.topic7Desc'),
      image:
        'https://readdy.ai/api/search-image?query=A%20glossy%20green%20shield%20with%20a%20white%20checkmark%20symbol%20representing%20trust%20and%20security%20on%20a%20light%20studio%20background%2C%20soft%20even%20lighting%2C%20minimal%203d%20render%20photography%2C%20clean%20modern%20aesthetic%2C%20high%20detail&width=800&height=600&seq=topic-legit&orientation=landscape',
    },
  ];

  return (
    <>
      {/* Topics */}
      <section className="bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
          <div className="mx-auto max-w-2xl text-center">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{t('home.topics.title')}</h2>
            <p className="mt-3 text-base text-foreground-600">{t('home.topics.subtitle')}</p>
          </div>

          <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {topics.map((topic) => (
              <Link
                key={topic.title}
                to="/usfans-spreadsheet-guide"
                className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-0.5 hover:border-primary-300"
              >
                <div className="relative h-36 w-full overflow-hidden">
                  <img
                    src={topic.image}
                    alt={topic.title}
                    title={`${topic.title} - USFans Spreadsheet`}
                    className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 flex h-9 w-9 items-center justify-center rounded-lg bg-background-50/90 text-primary-600 backdrop-blur">
                    <i className={`${topic.icon} text-lg`} />
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-700">
                    {topic.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{topic.desc}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Guides */}
      <section id="guides" className="bg-background-50">
        <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
          <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
            <div className="max-w-xl">
              <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{t('home.guides.title')}</h2>
              <p className="mt-3 text-base text-foreground-600">{t('home.guides.subtitle')}</p>
            </div>
          </div>

          <div className="mt-8">
            <Link
              to="/usfans-spreadsheet-guide"
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-all hover:-translate-y-0.5 hover:border-primary-300 md:flex-row"
            >
              <div className="h-44 w-full overflow-hidden md:h-auto md:w-72">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20clean%20modern%20desk%20with%20a%20laptop%20showing%20a%20product%20spreadsheet%20and%20a%20notebook%20with%20notes%2C%20soft%20natural%20light%2C%20minimal%20workspace%20photography%2C%20fresh%20modern%20aesthetic%2C%20high%20detail%2C%20editorial%20composition&width=800&height=600&seq=guide-feature&orientation=landscape"
                  alt={t('home.guides.articleTitle')}
                  title={`${t('home.guides.articleTitle')} - USFans Spreadsheet`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="flex flex-1 flex-col justify-center p-6">
                <div className="flex flex-wrap items-center gap-2 text-xs font-medium text-foreground-500">
                  <span className="rounded-full bg-primary-100 px-2.5 py-1 text-primary-800">{t('home.guides.articleCategory')}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line text-sm" />
                    {t('home.guides.articleReadingTime')}
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-xl font-bold text-foreground-950 group-hover:text-primary-700">
                  {t('home.guides.articleTitle')}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{t('home.guides.articleSummary')}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-primary-700">
                  {t('home.guides.readMore')}
                  <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-0.5" />
                </span>
              </div>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}